import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MeetingPageComponent } from './meeting-page/meeting-page.component';
import { SalesCoachConfigPageComponent } from './sales-coach-config-page/sales-coach-config-page.component';
import { MeetingPageV2Component } from './meeting-page/meeting-page-v2/meeting-page-v2.component';

const routes: Routes = [
  {
    path: 'meeting/:conversationId',
    component: MeetingPageComponent,
  },
  {
    path: 'meeting-v2/:conversationId',
    component: MeetingPageV2Component,
  },
  {
    path: 'config',
    component: SalesCoachConfigPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeetingAnalysisRoutingModule {}
